const { extend } = require('underscore')
const formatLabel = require('./format_label')
const generateLabels = require('./generate_labels')

const common = {
  animation: {
    duration: 0
  },
  maintainAspectRatio: false,
  /**
   * This makes charts react to window resizing. However,
   * on ChartView initialization level (ChartView.getIsNarrow),
   * we select chart layout type at the rendering moment,
   * which won't be changed unless re-rendered.
   */
  responsive: true,
  tooltips: {
    enabled: false
  }
}

const getPieConfig = ({ config, isNarrow }) => ({
  legend: {
    position: isNarrow ? 'bottom' : 'left',
    labels: {
      fontSize: config.fontSizeBase,
      fontColor: config.colorCategory,
      fontFamily: config.fontFamily,
      boxWidth: 15,
      padding: 15,
      generateLabels
    }
  }
})

const getBarConfig = ({ config, xAxisLabel, isNarrow }) => {
  let xScaleLabel = {
    display: true,
    fontSize: config.fontSizeAux,
    fontColor: config.colorTicks,
    fontFamily: config.fontFamily,
    lineHeight: 1.4
  }

  if (xAxisLabel) {
    xScaleLabel['labelString'] = xAxisLabel
  }

  return {
    layout: {
      padding: {
        right: isNarrow ? 0 : 50
      }
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [{
        gridLines: {
          borderDash: [2, 2],
          color: config.colorGrid,
          drawBorder: false,
          zeroLineBorderDash: [2, 2],
          zeroLineColor: config.colorGrid,
          zeroLineWidth: 0
        },
        scaleLabel: xScaleLabel,
        ticks: {
          beginAtZero: true,
          callback: value => formatLabel(value, config.unitLabel),
          fontColor: config.colorTicks,
          fontSize: config.fontSizeAux,
          fontFamily: config.fontFamily,
          padding: 5
        }
      }],
      yAxes: [{
        display: !isNarrow,
        barPercentage: 0.15,
        gridLines: {
          display: false,
          drawBorder: false
        },
        ticks: {
          fontColor: config.colorCategory,
          fontSize: config.fontSizeBase,
          fontFamily: config.fontFamily
        }
      }]
    }
  }
}

module.exports = options => {
  const {
    config,
    type,
    labels,
    data,
    colors,
    xAxisLabel,
    isNarrow,
    plugins
  } = options
  let specificConfig

  if (type === 'pie') {
    specificConfig = getPieConfig({ config, isNarrow })
  } else if (type === 'horizontalBar') {
    specificConfig = getBarConfig({ config, xAxisLabel, isNarrow })
  }

  if (config.animateWhenVisible) {
    specificConfig.animation = {
      duration: config.animationDuration
    }
  }

  return {
    type,
    data: {
      labels,
      datasets: [{
        borderWidth: 0,
        backgroundColor: colors,
        data
      }]
    },
    options: extend({}, common, specificConfig),
    plugins
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/helpers/chart_options.js